import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Card } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import UserFullname from '~/components/userFullname/userFullname';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import { Link } from 'react-router-dom';

export const getIngredientAdjustmentsQuery = gql`
  query ingredientAdjustments($breweryId: Int!, $ingredientId: Int!, $limit: Int) {
    ingredientAdjustments(breweryId: $breweryId, ingredientId: $ingredientId, limit: $limit) {
      id
      lotId
      lot {
        id
        reference
      }
      amount
      stocktakeId
      createdAt
      createdByUser {
        firstName
        lastName
      }
    }
  }
`;

const AdjustmentBy = ({ lot, stocktakeId, createdByUser }) => {
  if (lot) {
    return <Link to={`/lots/${lot.id}`}>{lot.reference}</Link>;
  }

  if (stocktakeId) {
    return 'Via stocktake';
  }

  return (
    <span>
      Manually by <UserFullname user={createdByUser} />
    </span>
  );
};

const AdjustmentMovement = ({ amount }) => {
  if (parseFloat(amount) > 0) {
    return <span className="success">+{amount}</span>;
  }

  return <span className="error">{amount}</span>;
};

const RecentIngredientAdjustmentsList = ({ adjustments }) => {
  if (!adjustments.length) {
    return <p className="ma3">There have been no adjustments for this ingredient.</p>;
  }

  return (
    <table className="table mb0">
      <thead>
        <tr>
          <th className="bt-n bb-n table-header" />
          <th className="bt-n bb-n table-header">Adjustment</th>
          <th className="bt-n bb-n table-header">On</th>
          <th className="bt-n bb-n table-header">By</th>
        </tr>
      </thead>
      <tbody>
        {adjustments.map(a => (
          <tr className="table-row" key={a.id}>
            <td />
            <td>
              <AdjustmentMovement {...a} />
            </td>
            <td>{moment(a.createdAt).format('ddd Do MMM')}</td>
            <td>
              <AdjustmentBy {...a} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const RecentIngredientAdjustmentsCard = ({ brewery, id }) => {
  return (
    <div>
      <h3 className="f3 mt0">Recent stock adjustments</h3>
      <Card>
        <Query query={getIngredientAdjustmentsQuery} variables={{ breweryId: brewery.id, ingredientId: id, limit: 10 }}>
          {props => {
            const { loading, error, data } = props;
            if (loading) {
              return <Spinner className="absolute absolute-center stroke-brand-red" />;
            }

            if (error) {
              return <ErrorBoundaryContent error={error} />;
            }

            return <RecentIngredientAdjustmentsList adjustments={data.ingredientAdjustments} />;
          }}
        </Query>
      </Card>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(RecentIngredientAdjustmentsCard);



// WEBPACK FOOTER //
// ./src/containers/recentIngredientAdjustmentsCard/recentIngredientAdjustmentsCard.jsx